import { render, staticRenderFns } from "./WorkflowDesigner.vue?vue&type=template&id=034fa8d9&scoped=true"
import script from "./WorkflowDesigner.vue?vue&type=script&lang=js"
export * from "./WorkflowDesigner.vue?vue&type=script&lang=js"
import style0 from "./WorkflowDesigner.vue?vue&type=style&index=0&id=034fa8d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034fa8d9",
  null
  
)

export default component.exports